import { render, staticRenderFns } from "./MenuApps.vue?vue&type=template&id=6f4e0013&"
import script from "./MenuApps.vue?vue&type=script&lang=js&"
export * from "./MenuApps.vue?vue&type=script&lang=js&"
import style0 from "./MenuApps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports